<template>
  <div class="bannerCards">
    <div class="bannerCards__container">
      <div class="bannerCards__image"
           v-if="config.image">
        <a :href="config.image.link"
           :title="config.image.description"
           target="_blank">
          <img :src="config.image.background"
               :alt="config.image.description">
        </a>
      </div>
      <div class="bannerCards__row"
           v-else-if="config.products">
        <div v-for="item in config.products"
             class="bannerCards__item">
          <div class="bannerCards__item__img">
            <img :src="item.ImageURL"
                 :alt="item.Product_Name"/>
          </div>
          <div class="bannerCards__item__content">
            <h4 class="bannerCards__item__category"
                v-html="item.Category_4"></h4>
            <h3 class="bannerCards__item__product">
              {{item.Manufacturer}} {{item.Product_Name}}
            </h3>
            <span class="bannerCards__item__price"> &euro; {{item.Price}}</span>
            <a :href="item.link"
               :title="item.Product_Name"
               target="_blank"
               class="bannerCards__item__cta">scopri il prodotto</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default{
    data(){
      return {
        config: {}
      }
    },
    computed: {
      isMobile(){
        return window.innerWidth < 768;
      }
    },
    mounted(){
      var vm = this;
      vm.config = vm.$store.state.advertismentConfig;
    },
    updated(){
      var vm = this;
      vm.config = vm.$store.state.advertismentConfig;
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/globals/Advertisment.vue